/* global gtag */

const locationEvents = () => {
	if ('function' !== typeof gtag) {
		return;
	}

	const locationTitle = getCookie('trigger_user_location_set');

	if (locationTitle) {
		// console.log('User Location Set');

		gtag('event', 'User Location Set', {
			event_category: 'Location Finder',
			event_label: locationTitle,
		});

		document.cookie =
			'trigger_user_location_set=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
	}
};

const getCookie = (name) => {
	const cookieValue = document.cookie.match(
		'(^|;)\\s*' + name + '\\s*=\\s*([^;]+)'
	);
	return cookieValue ? decodeURIComponent(cookieValue.pop()) : null;
};

export default locationEvents;
